// THIS FILE IS AUTO GENERATED! Local values are for development only.
export const version = {
  hash: 'ea7a6375c4c5b9b3f450f80095108b618ee3779a',
  hashShort: 'ea7a637'
};
